// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"df964a54bf8625d3","4823":"eb922a91c5e7bd40","4989":"4f9c6a0808eba73f"}[chunkId] + ".css";
};